import Vue from 'vue';
import Vuex from 'vuex';

import { auth } from './auth.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth
   },
   mutations: {
    initRoutes(state, data) {
      state.routes = data;
    },
    // 切換語系設定
    setLang (state, value) {
      state.lang = value;
    }
  },
  state: {
    lang: null  // 存放使用者選用的語系
  }
});

